import * as yup from 'yup';

export const editThoughtLeadershipValidation = () => {
    const schema = yup.object().shape({
        resource_title: yup.string().label('This field').optional(),
        sitecore_id: yup.string().label('This field').optional(),
        resource_type: yup.string().label('This field').optional(),
        languages: yup.string().label('This field').optional(),
        available_to_all: yup.boolean().label('This field').optional(),
        excluded_client_accounts: yup.string().label('This field').optional(),
    })

    return { schema }
}